import type { FinalizeNpcSessionResponse } from '../store/api/npcApi';
import type { FinalizeSessionResponse } from '../store/api/practiceApi';
import { clampOrNull } from './scoreDisplay';

/**
 * The overall an NPC attempt is shown with: THIS attempt's canonical evidence
 * overall, the value the level authority judged (finalize-npc
 * `data.npc.levelResult.attemptScore`). Null — "—", not measured — before the
 * result arrives, for a not-evaluable attempt, and for a response without a
 * level result. Never the legacy heuristic overall (`scores.overall`), which
 * does not decide the level and can disagree with it.
 */
export function npcAttemptOverall(result: FinalizeNpcSessionResponse | null | undefined): number | null {
  const levelResult = result?.npc?.levelResult;
  if (!levelResult || levelResult.notEvaluable) return null;
  return clampOrNull(levelResult.attemptScore ?? null);
}

/**
 * The overall a session-bound practice attempt (training assignment, AI coach)
 * is shown with: THIS attempt's canonical evidence overall from the finalize
 * response (`attemptScore`) — the one result history, analytics and the
 * training assignment read, so the overall shown and the assignment outcome
 * agree (RC19). Null ("—") before finalize, when not measured, and from a
 * server that does not send it. Never the legacy heuristic `scores.overall`,
 * and never the preliminary analysis' overall.
 */
export function sessionAttemptOverall(result: Pick<FinalizeSessionResponse, 'attemptScore'> | null | undefined): number | null {
  return clampOrNull(result?.attemptScore ?? null);
}
